import type { RouteRecordRaw, RouteRecordSingleView } from 'vue-router';

import type { PublicDealSteps } from '@/models/deal/public/publicDealSteps.enum';

type PublicDealStepRoute = Omit<RouteRecordSingleView, 'name'> & {
  name: PublicDealSteps;
};

const steps: Array<PublicDealStepRoute> = [
  {
    name: 'PublicDealOnboarding',
    path: 'inicio',
    component: () =>
      import('@/views/public/deal/steps/1.OnboardingMessage.vue'),
    meta: { requiresAuth: false },
  },
  {
    name: 'PublicDealPersonAssociate',
    path: 'pessoa-fisica',
    component: () => import('@/views/public/deal/steps/2.PersonAssociate.vue'),
    meta: { requiresAuth: false },
  },
  {
    name: 'PublicDealCompanyAssociate',
    path: 'pessoa-juridica',
    component: () => import('@/views/public/deal/steps/3.CompanyAssociate.vue'),
    meta: { requiresAuth: false },
  },
  {
    name: 'PublicDealAssociateSummary',
    path: 'resumo-proponentes',
    component: () => import('@/views/public/deal/steps/4.AssociateSummary.vue'),
    meta: { requiresAuth: false },
  },
  {
    name: 'PublicDealAssetData',
    path: 'dados-da-operacao',
    component: () => import('@/views/public/deal/steps/5.AssetData.vue'),
    meta: { requiresAuth: false },
  },
  {
    name: 'PublicDealSummary',
    path: 'resumo-do-negocio',
    component: () => import('@/views/public/deal/steps/6.DealSummary.vue'),
    meta: { requiresAuth: false },
  },
  {
    name: 'PublicDealFilesUpload',
    path: 'arquivos',
    component: () => import('@/views/public/deal/steps/7.FilesUpload.vue'),
    meta: { requiresAuth: false },
  },
  {
    name: 'PublicDealSuccessMessage',
    path: 'sucesso',
    component: () => import('@/views/public/deal/steps/8.SuccessMessage.vue'),
    meta: { requiresAuth: false },
  },
];

/**
 * Ambiente público
 * Módulo do deal
 */
export const dealRoutes: Array<RouteRecordRaw> = [
  {
    name: 'PublicDealLayout',
    path: '/cadastro-cliente',
    props: false,
    meta: { requiresAuth: false },
    component: () => import('@/views/public/PublicLayout.vue'),
    children: [
      {
        name: 'PublicDealView',
        path: ':assetSegment/:operationType/:tokenOrUsername',
        props: true,
        component: () => import('@/views/public/deal/PublicDealView.vue'),
        meta: { requiresAuth: false },
        children: steps,
      },
    ],
  },
];
